var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-button",
    {
      style: _vm.buttonStyle,
      attrs: { type: "primary", size: _vm.size },
      on: { click: _vm.handlerClick },
    },
    [_vm._v(_vm._s(_vm.buttonText))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }